import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { InputField } from "../../../../../components/input-field/InputField";
import { InputButton } from "../../../../../components/input-button/InputButton";
import { BusinessWithdrawTarificationService } from "../../../../../services/BusinessWithdrawTarificationService";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { validateFile } from "../../../../../common/Hooks";
import IcipWithdrawTarificationService from "../../../../../services/IcipWithdrawTarificationService";
import { Autocomplete } from "@material-ui/lab";
import PricingService from "../../../../../services/PricingService";

interface AddPricingProps {
  currencies: any[];
  countries: any[];
  operators: any[];
  pricingGroups: any[];
  onSubmitCallback: () => void;
  //handleEditCallBack: (e, data) => void;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalTitle: {
    fontSize: 25,
    fontWeight: "bold",
  },
  modalBody: {
    //width: 500,
    padding: 20,
    border: "none",
    overflow: "auto",
  },
  searchAuto: {
    //border: '1px outset lightgray',
  },

  antPickerDropdown: {
    zIndex: 100000,
  },
}));

export const AddPricing = (props: AddPricingProps) => {
  const classes = useStyles();
  const intl = useIntl();
  const { formatMessage } = useIntl();
  //const { branchId, isOpened, closeCallback } = props;
  const { operators, pricingGroups, onSubmitCallback } = props;
  const [branchId, setBranchID] = useState(2);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [succeed, setSucceed] = useState(false);
  const [currencies, setCurrencies] = useState(props.currencies);
  const [countries, setCountries] = useState(props.countries);
  //const [operators, setOperators] = useState(props.operators);

  const formik = useFormik({
    initialValues: {
      min_amount: "",
      max_amount: "",
      commission_percentage: "",
      fees: "",
      origin_country_id: "",
      destination_country_id: "",
      pricing_group_id: "",
      operator_id: 1,
      origin_currency_id: "",
      destination_currency_id: "",
    },
    validationSchema: Yup.object().shape({
      min_amount: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterMinAmount" })
      ),
      max_amount: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterMaxAmount" })
      ),
      commission_percentage: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCommissionPercentage" })
      ),
      fees: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterFixedFees" })
      ),
      origin_country_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterOriginCountry" })
      ),
      destination_country_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterDestinationCountry" })
      ),
      pricing_group_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterPricingGroup" })
      ),
      origin_currency_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterOriginCurrency" })
      ),
      destination_currency_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterDestinationCurrency" })
      ),
    }),
    onSubmit: async (
      values,
      { setSubmitting, resetForm }: FormikHelpers<any>
    ) => {
      setError(false);
      try {
        const addPricingResult = await PricingService.addPricing(formik.values);
        if (addPricingResult.isSuccess && addPricingResult.data.code === 100) {
          resetForm({});
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
          onSubmitCallback();
        } else {
          setError(true);
          if (addPricingResult.data.code === 101) {
            setErrorMessage("Min amount must be lower than max amount");
          } else {
            if (addPricingResult.data.code === 102) {
              setErrorMessage("Similar tarification already exist");
            } else {
              if (addPricingResult.data.code === 103) {
                setErrorMessage(
                  "There is overlap with another tarification withdraw"
                );
              } else {
                setErrorMessage("");
              }
            }
          }
        }
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  useEffect(() => {
    //setPricingGroups2(pricingGroups);
  }, []);

  return (
    <>
      <Paper className={classes.modalBody}>
        <form noValidate onSubmit={formik.handleSubmit} autoComplete="off">
          <Grid container spacing={2}>
            <Grid
              item
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              xs={12}
              sm={12}
              lg={12}
            >
              <Typography
                className={classes.modalTitle}
                variant="h4"
                component="h4"
              >
                <FormattedMessage id="sharedScreen.addPricing" />
              </Typography>
            </Grid>
            {error && (
              <Grid item xs={12} sm={12} lg={12}>
                <Alert severity="error">
                  {errorMessage === "" && (
                    <FormattedMessage id="sharedScreen.thereWasAProblemCreatingPricing" />
                  )}
                  {errorMessage !== "" && <p>{errorMessage}</p>}
                </Alert>
              </Grid>
            )}
            <Grid item xs={10} sm={12} lg={12}>
              <InputField
                value={formik.values.min_amount}
                type="number"
                fullWidth
                label={formatMessage({
                  id: "sharedScreen.pricingMinAmount",
                })}
                placeholder={formatMessage({
                  id: "sharedScreen.pricingMinAmount",
                })}
                name="min_amount"
                onChange={formik.handleChange}
                error={
                  formik.touched.min_amount && Boolean(formik.errors.min_amount)
                }
                helperText={
                  formik.touched.min_amount && formik.errors.min_amount
                }
              />

              <InputField
                value={formik.values.max_amount}
                type="number"
                fullWidth
                label={formatMessage({
                  id: "sharedScreen.pricingMaxAmount",
                })}
                placeholder={formatMessage({
                  id: "sharedScreen.pricingMaxAmount",
                })}
                name="max_amount"
                onChange={formik.handleChange}
                error={
                  formik.touched.max_amount && Boolean(formik.errors.max_amount)
                }
                helperText={
                  formik.touched.max_amount && formik.errors.max_amount
                }
              />

              <InputField
                value={formik.values.commission_percentage}
                type="number"
                fullWidth
                label={formatMessage({
                  id: "sharedScreen.commissionPercentage",
                })}
                placeholder={formatMessage({
                  id: "sharedScreen.commissionPercentage",
                })}
                name="commission_percentage"
                onChange={formik.handleChange}
                error={
                  formik.touched.commission_percentage &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description &&
                  formik.errors.commission_percentage
                }
              />

              <InputField
                value={formik.values.fees}
                variant="outlined"
                type="number"
                fullWidth
                label={formatMessage({
                  id: "sharedScreen.fixedFees",
                })}
                placeholder={formatMessage({ id: "sharedScreen.fixedFees" })}
                name="fees"
                onChange={formik.handleChange}
                error={formik.touched.fees && Boolean(formik.errors.fees)}
                helperText={formik.touched.description && formik.errors.fees}
              />
            </Grid>

            <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                className={classes.searchAuto}
                id="countries"
                options={countries}
                renderInput={(param) => (
                  <TextField
                    {...param}
                    label={formatMessage({
                      id: "sharedScreen.originCountryId",
                    })}
                    variant="outlined"
                    size="small"
                  />
                )}
                getOptionLabel={(Option) => Option.designation}
                //onChange={formik.handleChange}
                onChange={(event, country) => {
                  {
                    country != null &&
                      formik.setFieldValue("origin_country_id", country.id);
                  }
                }}
              />
              {/*<TextField
                select
                variant="outlined"
                size="small"
                value={formik.values.origin_country_id}
                label={formatMessage({ id: "sharedScreen.originCountryId" })}
                fullWidth
                name="origin_country_id"
                onChange={formik.handleChange}
                error={
                  formik.touched.origin_country_id &&
                  Boolean(formik.errors.origin_country_id)
                }
                helperText={
                  formik.touched.origin_country_id && formik.errors.origin_country_id
                }
              >
                {countries.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.designation}
                  </MenuItem>
                ))}
                </TextField>*/}
            </Grid>

            <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                className={classes.searchAuto}
                id="countries"
                options={countries}
                renderInput={(param) => (
                  <TextField
                    {...param}
                    label={formatMessage({
                      id: "sharedScreen.destinationCountryId",
                    })}
                    variant="outlined"
                    size="small"
                  />
                )}
                getOptionLabel={(Option) => Option.designation}
                //onChange={formik.handleChange}
                onChange={(event, country) => {
                  {
                    country != null &&
                      formik.setFieldValue(
                        "destination_country_id",
                        country.id
                      );
                  }
                }}
              />
              {/*<TextField
                select
                variant="outlined"
                size="small"
                value={formik.values.destination_country_id}
                label={formatMessage({ id: "sharedScreen.destinationCountryId" })}
                fullWidth
                name="destination_country_id"
                onChange={formik.handleChange}
                error={
                  formik.touched.destination_country_id &&
                  Boolean(formik.errors.destination_country_id)
                }
                helperText={
                  formik.touched.destination_country_id && formik.errors.destination_country_id
                }
              >
                {countries.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.designation}
                  </MenuItem>
                ))}
                </TextField>*/}
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                className={classes.searchAuto}
                id="pricingGroups"
                options={pricingGroups}
                renderInput={(param) => (
                  <TextField
                    {...param}
                    label={formatMessage({ id: "sharedScreen.pricingGroupId" })}
                    variant="outlined"
                    size="small"
                  />
                )}
                getOptionLabel={(Option) => Option.code}
                //onChange={formik.handleChange}
                onChange={(event, pricingG) => {
                  {
                    pricingG != null &&
                      formik.setFieldValue("pricing_group_id", pricingG.id);
                  }
                }}
              />
              {/*<TextField
                select
                variant="outlined"
                size="small"
                value={formik.values.pricing_group_id}
                label={formatMessage({ id: "sharedScreen.pricingGroupId" })}
                fullWidth
                name="pricing_group_id"
                onChange={formik.handleChange}
                error={
                  formik.touched.pricing_group_id &&
                  Boolean(formik.errors.pricing_group_id)
                }
                helperText={
                  formik.touched.pricing_group_id && formik.errors.pricing_group_id
                }
              >
             {pricingGroups.map((pricingG) => (
                  <MenuItem key={pricingG.id} value={pricingG.id}>
                    {pricingG.designation}
                  </MenuItem>
               ))}
             </TextField>*/}
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                disabled
                hidden
                id="operators"
                options={operators}
                renderInput={(param) => (
                  <TextField
                    {...param}
                    label={formatMessage({ id: "sharedScreen.operatorId" })}
                  />
                )}
                getOptionLabel={(Option) => Option.code}
                //onChange={formik.handleChange}
                onChange={(event, operator) => {
                  {
                    operator != null &&
                      formik.setFieldValue("operator_id", operator.id);
                  }
                }}
              />
              {/*<TextField
                select
                variant="outlined"
                size="small"
                value={formik.values.operator_id}
                label={formatMessage({ id:"sharedScreen.operatorId"})}
                fullWidth
                name="operator_id"
                onChange={formik.handleChange}
                error={
                  formik.touched.operator_id &&
                  Boolean(formik.errors.operator_id)
                }
                helperText={
                  formik.touched.operator_id && formik.errors.operator_id
                }
              >
              {operators.map((op) => (
                  <MenuItem key={op.id} value={op.id}>
                    {op.code}
                  </MenuItem>
              ))}
              </TextField>*/}
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                className={classes.searchAuto}
                id="currencies"
                options={currencies}
                renderInput={(param) => (
                  <TextField
                    {...param}
                    label={formatMessage({
                      id: "sharedScreen.originCurrencyId",
                    })}
                    variant="outlined"
                    size="small"
                  />
                )}
                getOptionLabel={(Option) => Option.code}
                //onChange={formik.handleChange}
                onChange={(event, currency) => {
                  {
                    currency != null &&
                      formik.setFieldValue("origin_currency_id", currency.id);
                  }
                }}
              />
              {/*<TextField
                select
                variant="outlined"
                size="small"
                value={formik.values.origin_currency_id}
                label={formatMessage({ id:"sharedScreen.originCurrencyId"})}
                fullWidth
                name="operator_id"
                onChange={formik.handleChange}
                error={
                  formik.touched.origin_currency_id &&
                  Boolean(formik.errors.origin_currency_id)
                }
                helperText={
                  formik.touched.origin_currency_id && formik.errors.origin_currency_id
                }
              >
                {currencies.map((currency) => (
                  <MenuItem key={currency.id} value={currency.id}>
                    {currency.code}
                  </MenuItem>
                ))}
                </TextField>*/}
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                className={classes.searchAuto}
                id="currencies"
                options={currencies}
                renderInput={(param) => (
                  <TextField
                    {...param}
                    label={formatMessage({
                      id: "sharedScreen.destinationCurrencyId",
                    })}
                    variant="outlined"
                    size="small"
                  />
                )}
                getOptionLabel={(Option) => Option.code}
                //onChange={formik.handleChange}
                onChange={(event, currency) => {
                  {
                    currency != null &&
                      formik.setFieldValue(
                        "destination_currency_id",
                        currency.id
                      );
                  }
                }}
              />
              {/*<TextField
                select
                variant="outlined"
                size="small"
                value={formik.values.destination_currency_id}
                label={formatMessage({ id:"sharedScreen.destinationCurrencyId"})}
                fullWidth
                name="destination_currency_id"
                onChange={formik.handleChange}
                error={
                  formik.touched.destination_currency_id &&
                  Boolean(formik.errors.destination_currency_id)
                }
                helperText={
                  formik.touched.destination_currency_id && formik.errors.destination_currency_id
                }
              >
                {currencies.map((currency) => (
                  <MenuItem key={currency.id} value={currency.id}>
                    {currency.code}
                  </MenuItem>
                ))}
                </TextField>*/}
            </Grid>
            <br />
            <br />

            <Grid item xs={12} sm={12} lg={12} container direction="row">
              <InputButton
                disabled={formik.isSubmitting}
                fullWidth
                type="submit"
                variant="contained"
                color="secondary"
              >
                <FormattedMessage id="sharedScreen.create" />
                {formik.isSubmitting && <CircularProgress size={30} />}
              </InputButton>
            </Grid>
            {succeed && (
              <Grid item xs={12} sm={12} lg={12}>
                <Alert severity="success">
                  <FormattedMessage id="sharedScreen.icipWithdrawTarificationCreatedSuccessfully" />
                </Alert>
              </Grid>
            )}
          </Grid>
        </form>
      </Paper>
    </>
  );
};
